<template>
  <div id="container" class="cart_st">
    <!-- 약관 동의 START-->
    <div class="section full">
      <div class="inner">
        <div class="btn_wrap" data-detail="shortcuts">
          <router-link :to="{ name: 'orders' }" class="box_btn line">
            <span class="c_icon ico_shortcuts_arrow"></span>
            <span class="an_t">{{
              $t('views.member.seller.sellerstep2.9145')
            }}</span>
          </router-link>
        </div>
        <div class="box_wrap" data-detail="modify_detail">
          <div class="cart_progress">
            <div class="progress_box">
              <p class="cell">
                <span class="fn_mont">{{
                  $t('views.member.seller.sellerstep2.3905')
                }}</span
                >{{ $t('views.member.seller.sellerstep2.6483') }}
              </p>
            </div>
            <div class="c_icon ico_progress_arrow"></div>
            <div class="progress_box active">
              <p class="cell">
                <span class="fn_mont">{{
                  $t('views.member.seller.sellerstep2.3281')
                }}</span
                >{{ $t('views.member.seller.sellerstep2.9059') }}
              </p>
            </div>
            <div class="c_icon ico_progress_arrow"></div>
            <div class="progress_box">
              <p class="cell">
                <span class="fn_mont">{{
                  $t('views.member.seller.sellerstep2.2096')
                }}</span
                >{{ $t('views.member.seller.sellerstep2.4164') }}
              </p>
            </div>
          </div>

          <div class="box tac">
            <div class="box_title">
              <h2>{{ $t('views.member.seller.sellerstep2.592') }}</h2>
              <p class="guide_txt">
                {{ $t('views.member.seller.sellerstep2.411') }}
              </p>
            </div>

            <div class="modify_align">
              <ul class="form_wrap">
                <li>
                  <p class="sub_title">
                    {{ $t('views.member.seller.sellerstep2.8792') }}
                  </p>
                  <div class="input_wrap">
                    <input
                      v-model="accountHolder"
                      class="input_t"
                      type="text"
                      name="accountHolder"
                    />
                  </div>
                </li>
                <li class="bank_select">
                  <p class="sub_title">
                    {{ $t('views.member.seller.sellerstep2.310') }}
                  </p>
                  <div class="select_area">
                    <div
                      v-on-clickaway="closeBankSelect"
                      class="select_item"
                      :class="{ active: showBankSelect }"
                      @click="toggleBankSelect"
                    >
                      <button class="select_option gray">
                        <span class="txt">{{ bankName }}</span
                        ><span class="arrow blind">열기</span>
                      </button>

                      <ul class="select_list">
                        <li class="tit">
                          {{ $t('views.member.seller.sellerstep2.7956')
                          }}<button
                            type="button"
                            class="select_list_close an_a"
                          >
                            <span class="svg_close"></span
                            ><span class="an_t">{{
                              $t('library.deletemodal.close')
                            }}</span>
                          </button>
                        </li>
                        <li
                          v-for="(bank, idx) in banks"
                          :key="idx"
                          :class="{ active: bankName == bank.name }"
                        >
                          <button
                            type="button"
                            class="list_option"
                            @click="selectBank(bank.name)"
                          >
                            <span>{{ bank.name }}</span>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="input_wrap">
                    <input
                      v-model="accountNumber"
                      class="input_t"
                      type="number"
                      name="accountNumber"
                      :placeholder="$t('views.member.seller.sellerstep2.47')"
                    />
                  </div>
                </li>
                <li class="passbook_copy">
                  <p class="sub_title">
                    {{ $t('views.member.seller.sellerstep2.7320') }}
                  </p>
                  <div class="btn_wrap">
                    <!-- TODO: @Stan 통장 사본 file should be added here -->
                    <input
                      id="bankProofImg"
                      type="file"
                      name="bankProofImg"
                      hidden
                    />
                    <button class="box_btn" @click="uploadBankProof">
                      <span class="an_t">{{
                        $t('views.member.seller.sellerstep2.8698')
                      }}</span>
                    </button>
                    <span class="tt">{{
                      $t('views.member.seller.sellerstep2.8702')
                    }}</span>
                  </div>
                </li>
              </ul>
            </div>

            <div class="btn_wrap" data-detail="btn_bottom">
              <router-link :to="{ name: 'orders' }" class="box_btn dull">
                <span class="an_t">{{ $t('library.deletemodal.cancel') }}</span>
              </router-link>

              <button
                :class="{ dull: !valid }"
                class="box_btn"
                :disabled="!valid"
                @click="goToStep3"
              >
                <span class="an_t">{{
                  $t('views.member.seller.sellerstep2.7294')
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 약관 동의 END-->
  </div>
</template>

<script>
export default {
  name: 'SellerStep2',
  data() {
    return {
      showBankSelect: false,
      valid: false,
      // Temp v-model
      accountHolder: '',
      bankName: '은행 선택',
      accountNumber: '',

      // Temp data
      banks: [
        {
          id: 0,
          name: '카카오뱅크'
        },
        {
          id: 0,
          name: '국민은행'
        },
        {
          id: 0,
          name: '신한은행'
        },
        {
          id: 0,
          name: '하나은행'
        },
        {
          id: 0,
          name: '기업은행'
        },
        {
          id: 0,
          name: '농협은행'
        },
        {
          id: 0,
          name: '외환은행'
        },
        {
          id: 0,
          name: '씨티은행'
        },
        {
          id: 0,
          name: '대구은행'
        },
        {
          id: 0,
          name: '부산은행'
        },
        {
          id: 0,
          name: '광주은행'
        },
        {
          id: 0,
          name: '경남은행'
        },
        {
          id: 0,
          name: '제주은행'
        },
        {
          id: 0,
          name: '전북은행'
        },
        {
          id: 0,
          name: '수협'
        },
        {
          id: 0,
          name: '우체국'
        },
        {
          id: 0,
          name: '새마을금고'
        }
      ]
    }
  },
  methods: {
    uploadBankProof() {
      document.getElementById('bankProofImg').click()
    },
    toggleBankSelect() {
      this.showBankSelect = !this.showBankSelect
    },
    closeBankSelect() {
      this.showBankSelect = false
    },
    selectBank(value) {
      this.bankName = value
    },

    // Actions:
    goToStep3() {
      if (this.valid) {
        this.$router.push({ name: 'seller_step3' })
      }
      // TODO: @Stan add validation for bank input fields and then move to step3 when valid
    }
  }
}
</script>

<style lang="scss" scoped></style>
